<template lang="pug">
  #app
    navbar(v-if="user")
    router-view
  </div>
</template>

<script>
import Navbar from './components/UI/Navbar'
import { mapGetters, mapActions } from 'vuex'
import initializeFirebase from './plugins/firebase'

export default {
  components: {
    Navbar
  },
  methods: {
    checkAuth () {

      const { isPublic, roles } = this.$route.meta
      const name = this.$route.name
      
      if (isPublic) {
        if (this.user && name === 'Login') {
          /** Vista Login y usuario autenticado: Se redirecciona al Home */
          this.$router.push({ name: 'Home' })
        }
      } else if (!this.user) {
        /** Vista privada y usuario NO autenticado: Se redirecciona al Login */
        this.$router.push({ name: 'Login' })
      } else if (roles && !roles.includes(this.user.role)) {
        /** Usuario sin permisos para acceder a la ruta */
        this.$router.push({ name: 'Home' })
      }
    },
    restoreUserFromLocalStorage () {
      const storedUser = JSON.parse(window.localStorage.getItem('user'))
      if (storedUser && storedUser.user.email) {
        this.$store.commit('AuthenticationStore/SET_USER', { user: storedUser })
      }
    },
    ...mapActions('UserStore',['addNotificationToken'])
  },
  computed: {
    ...mapGetters('AuthenticationStore', ['user']),
  },
  watch: {
    async user () {
      this.checkAuth()
      if (this.user) {
        const token = await initializeFirebase()
        if (token) {
          this.addNotificationToken({ token })
        }
      }
    },
    $route () {
      this.checkAuth ()
    }
  },
  mounted () {
    this.checkAuth ()
  },
  created () {
    this.restoreUserFromLocalStorage()
  }
}
</script>

<style lang="scss">
@import '../src/style/global.scss';
html {
  height: 100%;
}
body {
  font-family: 'Open Sans';
  height: 100%;
}
#app {
  height: 100%;
}
</style>